import React, { useState, useEffect } from "react";
import { Container, Row, Col, Image, Form } from "react-bootstrap";
import { FaEdit, FaSave } from "react-icons/fa";
import aboutImageDefault from "./grocerybanner.png";

const Aboutmaamaas = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [userId, setUserId] = useState(null);

  const [aboutText, setAboutText] = useState({ aboutUs: "" });
  const [previewImage, setPreviewImage] = useState(aboutImageDefault);
  const [imageBase64, setImageBase64] = useState("");
  const [vendorId, setVendorId] = useState(null);
  const [aboutUsId, setAboutUsId] = useState(null)

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);
  useEffect(() => {
    if (vendorId) {
      fetchAboutUsData(vendorId);
    }
  }, [vendorId]);

  const fetchAboutUsData = async (vendorId) => {
    const token = localStorage.getItem("authToken"); // ✅ Get token

    if (!token) {
      console.warn("Auth token not found. Please log in again.");
      return;
    }

    try {
      const response = await fetch(
        `https://backend.maamaas.com/food/aboutus/${vendorId}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`, // ✅ Include token
          },
        }
      );

      if (response.ok) {
        const data = await response.json();

        // Store About Us text
        setAboutText({ aboutUs: data.aboutUs });

        // Store aboutUsId if present
        if (data.aboutUsId) {
          setAboutUsId(data.aboutUsId); // <-- Save aboutUsId here
        }

        // Handle image if present
        if (data.image) {
          const imageSrc = `data:image/jpeg;base64,${data.image}`;
          setPreviewImage(imageSrc);
          setImageBase64(data.image);
        }
      } else {
        console.warn("No About Us data found or failed to fetch.");
      }
    } catch (error) {
      console.error("Error fetching About Us data:", error);
    }
  };


  const handleTextChange = (e) => {
    setAboutText({ ...aboutText, aboutUs: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageBase64(reader.result.split(",")[1]);
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddAboutUs = async () => {
    const token = localStorage.getItem("authToken"); // ✅ Get auth token

    if (!vendorId || !token) {
      alert("Vendor ID or auth token not found. Please log in again.");
      return;
    }

    if (!aboutText.aboutUs.trim()) {
      alert("Please enter About Us text.");
      return;
    }

    if (!imageBase64) {
      alert("Please upload an image.");
      return;
    }

    const payload = {
      aboutUs: aboutText.aboutUs,
      image: imageBase64,
    };

    try {
      const response = await fetch(
        `https://backend.maamaas.com/food/aboutus/add/${vendorId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}` // ✅ Include token
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        alert("About Us content added successfully!");
      } else {
        const err = await response.json();
        alert(`Failed to save: ${err.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error while saving:", error);
      alert("Something went wrong. Please try again.");
    }
  };


  const handleEditSaveToggle = async () => {
    const token = localStorage.getItem("authToken"); // ✅ Get auth token

    if (isEditing) {
      // SAVE (PUT) mode
      if (!token) {
        alert("Auth token not found. Please log in again.");
        return;
      }

      if (!aboutText.aboutUs.trim()) {
        alert("Please enter About Us text.");
        return;
      }

      const payload = {
        aboutUs: aboutText.aboutUs,
        image: imageBase64,
      };

      try {
        const response = await fetch(
          `https://backend.maamaas.com/food/aboutus/gopi/${aboutUsId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}` // ✅ Include token
            },
            body: JSON.stringify(payload),
          }
        );

        if (response.ok) {
          alert("Updated successfully!");
        } else {
          const err = await response.json();
          alert(`Update failed: ${err.message || "Unknown error"}`);
        }
      } catch (error) {
        console.error("Error updating About Us:", error);
        alert("Something went wrong.");
      }
    }

    setIsEditing((prev) => !prev);
  };


  return (
    <Container fluid className="py-4">
      <Row
        style={{ border: "1px solid #bbb", borderRadius: "5px" }}
        className="align-items-center"
      >
        <div className="d-flex justify-content-center w-100 px-4 pt-3">
          <h1
            style={{
              color: "#b15dc6",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            ABOUT US
          </h1>

          <button
            onClick={handleAddAboutUs}
            style={{
              height: "35px",
              borderRadius: "5px",
              border: "none",
              background: "#b15cd6",
              color: "#fff",
              fontWeight: "bold",
              cursor: "pointer",
              width: "80px",
              marginLeft: "20px",
              marginTop: "8px",
            }}
          >
            Add+
          </button>

          <button
            onClick={handleEditSaveToggle}
            style={{
              height: "35px",
              borderRadius: "5px",
              border: "none",
              background: "#b15cd6",
              color: "#fff",
              fontWeight: "bold",
              cursor: "pointer",
              width: "40px",
              marginLeft: "20px",
              marginTop: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            {isEditing ? <FaSave /> : <FaEdit />}
            {/* {isEditing ? "Save" : "Edit"} */}
          </button>
        </div>

        <Col md={6} className="p-4">
          <Form.Control
            as="textarea"
            rows={10}
            value={aboutText.aboutUs}
            onChange={handleTextChange}
            readOnly={!isEditing}
            placeholder="Write about us..."
            style={{
              border: "none",
              outline: "none", // optional: removes blue focus ring
              resize: "none",
              boxShadow: "none",  // optional: disables resizing
              ...styles.text,
            }}
          />
        </Col>

        <Col md={6} className="text-center p-4">
          <div className="position-relative d-inline-block">
            {isEditing && (
              <input
                type="file"
                accept="image/*"
                id="imageUpload"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
            )}
            <label
              htmlFor={isEditing ? "imageUpload" : ""}
              style={{ cursor: isEditing ? "pointer" : "default" }}
            >
              <Image
                src={previewImage}
                alt="About Maamaa's Restaurant"
                fluid
                rounded
                style={styles.image}
              />
            </label>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
const styles = {
  container: {
    padding: "40px 0px",
    // Add this line
    borderRadius: "12px",
    backgroundColor: "#fff",

  },
  row: {
    borderRadius: "10px",
    margin: "0 auto",
    maxWidth: "1100px",
    display: "flex",
    flexWrap: "wrap",
    border: "2px solid rgb(177, 93, 198)",
    padding: "20px",
    backgroundColor: "#fff",
  },
  heading: {
    color: "#b15dc6",
    fontWeight: "bold",
    fontSize: "32px",
    marginBottom: "20px",
    textAlign: "left",
    fontFamily: "revert"
  },
  image: {
    width: "100%",
    objectFit: "cover",
    borderRadius: "12px",
    height: "310px",
    maxHeight: "350px",
    marginTop: "-20px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
  },
  text: {
    fontSize: "16px",
    color: "#333",
    lineHeight: "1.8",
    textAlign: "justify",
    border: "none",
    fontFamily: 'math'
  },
};


export default Aboutmaamaas;
